import { render } from "./Big2Form.vue?vue&type=template&id=fd1c02ac&scoped=true"
import script from "./Big2Form.vue?vue&type=script&lang=js"
export * from "./Big2Form.vue?vue&type=script&lang=js"

import "./Big2Form.vue?vue&type=style&index=0&id=fd1c02ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd1c02ac"]])

export default __exports__